import React from "react";
import moment from "moment";
import useControllers from "../../../controllers";

/**
 * Primary UI component for user interaction
 */
export const Footer = () => {
  const { useComponentsHooks } = useControllers();
  const { useNavigation } = useComponentsHooks();

  const {
    goToPP,
    goToTC,
    goToFacebook,
    goToTwitter,
    goToInstagram,
    goToYoutube,
    goToTiktok,
    colors,
    handleRedirect,
    handleValidateHasLinks,
  } = useNavigation();

  return (
    <footer className="bg-gray-100 py-3">
      <div className="container text-center font-light color-gray700 text-sm mx-auto">
        <ul className="px-4">
          {goToTC && (
            <li>
              <span onClick={() => handleRedirect(goToTC)} className='font-bold underline' style={{ cursor: "pointer" }}>
                Términos y condiciones
              </span>
            </li>
          )}
          {goToPP && (
            <li>
              <span onClick={() => handleRedirect(goToPP)} className='font-bold underline' style={{ cursor: "pointer" }}>
                Políticas de privacidad
              </span>
            </li>
          )}
        </ul>
        <hr className="border-gray-600 max-w-xs mx-auto my-5 w-9/12" />
        {handleValidateHasLinks() && <p>Síguenos en</p>}
        <ul className="flex justify-center space-x-4 items-center my-6">
          {goToFacebook && (
            <li>
              <span onClick={() => handleRedirect(goToFacebook)} style={{ cursor: "pointer" }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 19.88" className="w-5">
                  <path
                    id="Trazado_22323"
                    data-name="Trazado 22323"
                    d="M126,1035a10,10,0,1,0-11.562,9.88v-6.99H111.9V1035h2.54v-2.2a3.526,3.526,0,0,1,3.777-3.89,15.809,15.809,0,0,1,2.238.19v2.46h-1.261a1.445,1.445,0,0,0-1.63,1.56V1035h2.774l-.443,2.89h-2.331v6.99A10,10,0,0,0,126,1035Z"
                    transform="translate(-106 -1025)"
                    fill={colors.secondary ? colors.secondary : "#616161"}
                  />
                </svg>
              </span>
            </li>
          )}
          {goToYoutube && (
            <li>
              <span onClick={() => handleRedirect(goToYoutube)} style={{ cursor: "pointer" }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14.07" className="w-6">
                  <path
                    id="Trazado_22324"
                    data-name="Trazado 22324"
                    d="M169.8,1031a4.283,4.283,0,0,0-.8-1.98,2.823,2.823,0,0,0-2-.85c-2.8-.21-7-.21-7-.21H160s-4.2,0-7,.21a2.823,2.823,0,0,0-2,.85,4.26,4.26,0,0,0-.793,1.98,29.864,29.864,0,0,0-.2,3.24v1.51a30.455,30.455,0,0,0,.2,3.24,4.37,4.37,0,0,0,.793,1.99,3.4,3.4,0,0,0,2.207.85c1.6.15,6.8.2,6.8.2s4.2-.01,7-.21a2.846,2.846,0,0,0,2-.84,4.345,4.345,0,0,0,.8-1.99,30.207,30.207,0,0,0,.2-3.24v-1.51A30.455,30.455,0,0,0,169.8,1031Zm-11.867,6.59v-5.62l5.4,2.82Z"
                    transform="translate(-150 -1027.96)"
                    fill={colors.secondary ? colors.secondary : "#616161"}
                  />
                </svg>
              </span>
            </li>
          )}
          {goToInstagram && (
            <li>
              <span onClick={() => handleRedirect(goToInstagram)} style={{ cursor: "pointer" }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.988 20" className="w-5">
                  <g id="Grupo_9434" data-name="Grupo 9434" transform="translate(-196 -733)">
                    <path
                      id="Trazado_22325"
                      data-name="Trazado 22325"
                      d="M204,1026.8c2.672,0,2.988.01,4.039.06a5.61,5.61,0,0,1,1.856.34,3.086,3.086,0,0,1,1.148.75,3.029,3.029,0,0,1,.746,1.15,5.46,5.46,0,0,1,.344,1.85c.047,1.06.058,1.37.058,4.04s-.011,2.99-.058,4.04a5.476,5.476,0,0,1-.344,1.86,3.158,3.158,0,0,1-.746,1.15,3.094,3.094,0,0,1-1.148.74,5.376,5.376,0,0,1-1.856.34c-1.055.05-1.371.06-4.039.06s-2.988-.01-4.039-.06a5.354,5.354,0,0,1-1.856-.34,3.261,3.261,0,0,1-1.894-1.89,5.535,5.535,0,0,1-.344-1.86c-.047-1.05-.058-1.37-.058-4.04s.011-2.99.058-4.04a5.46,5.46,0,0,1,.344-1.85,3.077,3.077,0,0,1,.746-1.15,3.118,3.118,0,0,1,1.148-.75,5.634,5.634,0,0,1,1.856-.34C201.012,1026.81,201.328,1026.8,204,1026.8Zm0-1.8c-2.715,0-3.055.01-4.121.06a7.563,7.563,0,0,0-2.426.46,4.9,4.9,0,0,0-1.773,1.16,4.831,4.831,0,0,0-1.157,1.77,7.316,7.316,0,0,0-.464,2.43c-.047,1.07-.059,1.41-.059,4.12s.012,3.05.059,4.12a7.369,7.369,0,0,0,.464,2.43,4.831,4.831,0,0,0,1.157,1.77,4.758,4.758,0,0,0,1.769,1.15,7.3,7.3,0,0,0,2.426.47c1.066.04,1.406.06,4.121.06s3.055-.02,4.121-.06a7.271,7.271,0,0,0,2.426-.47,4.769,4.769,0,0,0,1.77-1.15,4.829,4.829,0,0,0,1.152-1.77,7.327,7.327,0,0,0,.465-2.42c.047-1.07.058-1.41.058-4.13s-.011-3.05-.058-4.12a7.272,7.272,0,0,0-.465-2.42,4.609,4.609,0,0,0-1.145-1.78,4.885,4.885,0,0,0-1.769-1.15,7.292,7.292,0,0,0-2.426-.47C207.055,1025.01,206.715,1025,204,1025Z"
                      transform="translate(2 -292)"
                      fill={colors.secondary ? colors.secondary : "#616161"}
                    />
                    <path
                      id="Trazado_22326"
                      data-name="Trazado 22326"
                      d="M204,1029.86a5.14,5.14,0,1,0,5.137,5.14A5.138,5.138,0,0,0,204,1029.86Zm0,8.47a3.33,3.33,0,1,1,3.332-3.33A3.331,3.331,0,0,1,204,1038.33Z"
                      transform="translate(2 -292)"
                      fill={colors.secondary ? colors.secondary : "#616161"}
                    />
                    <path
                      id="Trazado_22327"
                      data-name="Trazado 22327"
                      d="M210.539,1029.66a1.2,1.2,0,1,1-1.2-1.2A1.2,1.2,0,0,1,210.539,1029.66Z"
                      transform="translate(2 -292)"
                      fill={colors.secondary ? colors.secondary : "#616161"}
                    />
                  </g>
                </svg>
              </span>
            </li>
          )}
          {goToTwitter && (
            <li>
              <span onClick={() => handleRedirect(goToTwitter)} style={{ cursor: "pointer" }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13" className="w-5">
                  <path
                    d="M15.7369 1.49955C15.1878 1.74613 14.5981 1.91256 13.9782 1.98659C14.6103 1.60375 15.0959 0.997433 15.3249 0.275136C14.733 0.629212 14.078 0.88758 13.3806 1.02572C12.8217 0.424593 12.0258 0.0488281 11.1446 0.0488281C9.45354 0.0488281 8.08342 1.43402 8.08342 3.14311C8.08342 3.38545 8.11001 3.62213 8.16226 3.84843C5.61748 3.71925 3.36147 2.48729 1.85094 0.615068C1.58783 1.0724 1.43668 1.60375 1.43668 2.17093C1.43668 3.24495 1.97736 4.19167 2.7984 4.74706C2.29691 4.73056 1.82481 4.59195 1.41196 4.35998C1.41149 4.37271 1.41149 4.38639 1.41149 4.39864C1.41149 5.8984 2.46672 7.14922 3.86763 7.43352C3.61105 7.50377 3.34048 7.54196 3.06105 7.54196C2.86325 7.54196 2.67198 7.52263 2.48538 7.4868C2.87444 8.71546 4.00571 9.61031 5.34504 9.63577C4.29774 10.4656 2.97754 10.9611 1.54304 10.9611C1.2958 10.9611 1.05182 10.9465 0.8125 10.9177C2.16723 11.7947 3.77666 12.3071 5.50599 12.3071C11.1376 12.3071 14.2179 7.59194 14.2179 3.50237C14.2179 3.36847 14.2142 3.23458 14.2086 3.10162C14.8071 2.66551 15.3259 2.12095 15.7369 1.49955Z"
                    fill={colors.secondary ? colors.secondary : "#616161"}
                  />
                </svg>
              </span>
            </li>
          )}
          {goToTiktok && (
            <li>
              <span onClick={() => handleRedirect(goToTiktok)} style={{ cursor: "pointer" }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 15" className="w-6">
                  <path
                    d="M11.0829 3.25285C10.9879 3.20313 10.8953 3.14862 10.8057 3.08954C10.5449 2.91508 10.3059 2.70952 10.0936 2.47727C9.56262 1.86234 9.3643 1.23849 9.29125 0.801711H9.29418C9.23316 0.439163 9.25839 0.20459 9.26221 0.20459H6.84361V9.67005C6.84361 9.79714 6.84361 9.92274 6.83833 10.0469C6.83833 10.0623 6.83686 10.0765 6.83598 10.0932C6.83598 10.1 6.83598 10.1071 6.83452 10.1143V10.1196C6.80902 10.4592 6.70146 10.7873 6.52128 11.075C6.3411 11.3626 6.09384 11.6011 5.80124 11.7693C5.49629 11.9449 5.15138 12.037 4.80054 12.0366C3.67368 12.0366 2.7604 11.1066 2.7604 9.95807C2.7604 8.80956 3.67368 7.87958 4.80054 7.87958C5.01385 7.87938 5.22584 7.91335 5.42866 7.98024L5.43159 5.48782C4.8159 5.40733 4.19041 5.45685 3.59457 5.63327C2.99874 5.80969 2.4455 6.10917 1.96975 6.51282C1.55288 6.87941 1.20242 7.31681 0.934128 7.80535C0.832033 7.9835 0.44683 8.69939 0.400183 9.86127C0.370846 10.5207 0.566528 11.204 0.659821 11.4864V11.4923C0.718497 11.6586 0.945863 12.226 1.3164 12.7044C1.61518 13.0881 1.96819 13.4251 2.36405 13.7047V13.6988L2.36991 13.7047C3.54078 14.51 4.83897 14.4571 4.83897 14.4571C5.06369 14.4479 5.8165 14.4571 6.6714 14.0471C7.61959 13.5925 8.1594 12.9152 8.1594 12.9152C8.50426 12.5105 8.77848 12.0493 8.97029 11.5514C9.18915 10.9691 9.26221 10.2707 9.26221 9.99162V4.96998C9.29154 4.9878 9.68232 5.24939 9.68232 5.24939C9.68232 5.24939 10.2453 5.61461 11.1237 5.85245C11.7538 6.0217 12.6029 6.05733 12.6029 6.05733V3.62728C12.3054 3.65994 11.7013 3.56492 11.0829 3.25285Z"
                    fill={colors.secondary ? colors.secondary : "#616161"}
                  />
                </svg>
              </span>
            </li>
          )}
        </ul>
        <p>No compartas contenido con menores de edad</p>
        <p>Todos los derechos reservados a {moment().year()}</p>
        <a href="https://www.ab-inbev.com/" className="uppercase hover:underline">
          Anheuser-Busch Inbev
        </a>
      </div>
    </footer>
  );
};

export default Footer;
